import {
  Box,
  Text,
  FormControl,
  Icon,
  // FormErrorMessage,
  FormLabel,
  Switch as ChakraSwitch,
  SwitchProps as ChakraSwitchProps,
} from '@chakra-ui/react';
import React from 'react';
import { useFormContext, Controller } from 'react-hook-form';
import { useTranslation } from 'react-i18next';
import { FaDiscord } from 'react-icons/fa';

const DiscordSwitch = ({
  name = 'createDiscordChannel',
  ...inputProps
}) => {
  const { t } = useTranslation();
  const { control } = useFormContext();

  return (
    <Box w="full" zIndex={0}>
      <Text fontWeight={500} mb={1}>
        <Icon as={FaDiscord} fontSize="20px"/>{" "}
        {t('Discord channel')}
      </Text>
      <FormControl display="flex" alignItems="center">
        <Controller
          control={control}
          name={name}
          defaultValue={false}
          render={({ field: { onChange, value, ref } }) => (
            <ChakraSwitch
              onChange={(e) => onChange(e.target.checked)}
              ref={ref}
              isChecked={value}
              colorScheme="purple"
              size="sm"
              {...inputProps}
            />
          )}
        />
        <FormLabel ml={2} htmlFor={name} mb={0} fontSize="14px">
          {t('Inactive / active')}
        </FormLabel>
      </FormControl>
    </Box>
  );
};

export default DiscordSwitch;
